export default __webpack_public_path__ + "static/media/clearberry.9c31904e.png";